module.exports = __webpack_public_path__ + "img/profil_switch_dark.ef9b2f70.png";